import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const clearData = () => initialState;

const setCount = (_, { payload }) => payload;

export default createReducer(initialState, {
  [types.SET_QUESTION_MODEL_STATISTICS_ID]: clearData,
  [types.QUESTION_MODEL_STATISTICS_COUNT_SUCCESS]: setCount,
  [types.QUESTION_MODEL_STATISTICS_COUNT_FAILURE]: clearData,
  [types.CLEAR_QUESTION_MODEL_STATISTIC]: clearData,
});
